import Modal from '../Modal';
import { Text } from '../../typography';
import { useModal } from '../../../providers/ModalProvider';
import { modals } from '../../../providers/modals';
import { Form } from 'react-bootstrap';
import styles from './TimecardModal.module.scss';
import { keys } from '../../../utilities/translator/translation_keys';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { paths } from '../../../constants/strings';
import { loader } from 'graphql.macro';
import { useMutation } from '@apollo/client';

const addTimecardMutation = loader('./TimecardModal.create.graphql');

export default function TimecardModal() {
  const navigate = useNavigate();
  const { closeModal, updateModal, modalState } = useModal();
  const { t } = useTranslation();
  const [addTimecard] = useMutation(addTimecardMutation);

  const { show, copyFromPrev, description } = modalState.timecardModal;

  const update = (variables) =>
    updateModal({
      modalName: modals.timecard,
      variables: { ...modalState, ...variables },
    });

  const onHide = () => closeModal({ modalName: modals.timecard });

  const onSubmit = async () => {
    const {
      data: {
        addTimecard: { id: newId },
      },
    } = await addTimecard({
      variables: { ...modalState.timecardModal },
    });
    if (newId) {
      navigate(`${paths.timecard}?id=${newId}`);
    }
    onHide();
  };
  return (
    <Modal
      open={show}
      title={'Add Timecard'}
      onSubmit={async () => await onSubmit()}
      onClose={onHide}
      onCancel={onHide}
      submitDisabled={!copyFromPrev && !description}
    >
      <div>
        <Text marginXs weight="semiBold">
          {t(keys.common.DESCRIPTION)}
        </Text>
        <Form.Control
          as="textarea"
          rows={4}
          value={description}
          onChange={({ target: { value } }) => update({ description: value })}
        />
        <br />
      </div>
      <div className={styles.flexRow}>
        <Form.Check
          type="switch"
          checked={copyFromPrev}
          onChange={({ target: { checked } }) =>
            update({ copyFromPrev: checked })
          }
        />
        <Text noMargin>Copy from Last Timecard</Text>
      </div>
    </Modal>
  );
}
